import s from './CertificationList.module.sass'
import cn from 'clsx'

import type { CertificationList as CertificationListType } from '../../../../../apps/benmax/src/types/sanity.types'

import { Copy, ImageBox, Button, NavLink } from 'shared-components'

import { getSanityLink } from 'shared-functions'

function CertificationList({
    title,
    lightTitlePadding,
    copy,
    link,
    mainBackgroundColour,
    certifications,
}: CertificationListType) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    const isLight = mainBackgroundColour === 'light'

    return (
        <section
            className={cn(s.CertificationList, isLight && s.Light, lightTitlePadding === 'no' && s.NoLightTitlePadding)}
        >
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    <div className={s.Title}>{title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}</div>
                    {copy && (
                        <div className={s.Copy}>
                            <Copy copy={copy} size="medium" />
                            {_link && <Button {..._link} inverted={!isLight} />}
                        </div>
                    )}
                </div>
                <ul className={s.Certifications}>
                    {certifications?.map((cert, index) => {
                        const { image, copy, url } = cert

                        const inner = (
                            <div className={s.Certification}>
                                {image && (
                                    <div className={s.Image}>
                                        <ImageBox image={image} width={85} height={85} />
                                    </div>
                                )}
                                {copy && <Copy copy={copy} size="medium" className={s.CertCopy} />}
                            </div>
                        )

                        return <li key={index}>{url ? <NavLink href={url}>{inner}</NavLink> : inner}</li>
                    })}
                </ul>
            </div>
        </section>
    )
}

export default CertificationList
